import { Component, OnInit } from '@angular/core';
import { HxAuthService, NotifierService } from 'hx-services';
import { AppService } from '@profile-app/app.service';
import { environment } from '@profile-env/environment';
import { en_US, NzI18nService, ru_RU } from 'ng-zorro-antd/i18n';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { NzContentComponent, NzHeaderComponent, NzLayoutComponent, NzSiderComponent } from 'ng-zorro-antd/layout';
import { NzMenuDirective, NzMenuItemComponent } from 'ng-zorro-antd/menu';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzSpaceCompactComponent } from 'ng-zorro-antd/space';
import { NzTagComponent } from 'ng-zorro-antd/tag';
import { NzDropDownDirective, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
  imports: [RouterLink, NgClass, NgIf, RouterOutlet, TranslocoPipe, NzLayoutComponent, NzSiderComponent, NzMenuDirective, NzMenuItemComponent, NzIconDirective, NzHeaderComponent, NzColDirective, NzSpaceCompactComponent, NzTagComponent, NzDropdownMenuComponent, NzButtonComponent, NzDropDownDirective, NzContentComponent, NzTooltipDirective, NzRowDirective]
})
export class AppComponent implements OnInit {

  isCollapsed = false;
  theme: 'light' | 'dark' = 'light'; // dark
  hasAppUpdate = false;
  isProd = environment.production;

  constructor(
    public auth: HxAuthService,
    private appService: AppService,
    private notifierService: NotifierService,
    private i18n: NzI18nService,
  ) {
  }

  ngOnInit(): void {
    this.appService.startUpdateChecker();
    this.appService.update.subscribe(() => this.hasAppUpdate = true);
    this.notifierService.start();
    if (this.auth.getUiLang() === 'en') {
      this.i18n.setLocale(en_US);
    } else {
      this.i18n.setLocale(ru_RU);
    }
  }

  updateApp() {
    this.appService.updateApp();
  }

  checkForUpdate() {
    this.appService.checkUpdates();
  }

  aboutApp() {
    this.appService.about();
  }
}
